export default {
  fonts: {
    body: "'OpenSans', sans-serif",
  },
};
